<template>
  <div>
    <ul class="polarity-list">
      <li>
        <DsIcon
          name="sentiment-positive"
          size="small"
          space="right"
          class="sentiment-color--success"
        />
        <span>{{ polarity.positive }}</span>
      </li>
      <li>
        <DsIcon
          name="sentiment-neutral"
          size="small"
          space="right"
          class="sentiment-color--neutral"
        />
        <span>{{ polarity.neutral }}</span>
      </li>
      <li>
        <DsIcon
          name="sentiment-negative"
          size="small"
          space="right"
          class="sentiment-color--negative"
        />
        <span>{{ polarity.negative }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { DsIcon } from '@ds/icons';

export default {
  name: 'FeelingList',
  components: {
    DsIcon,
  },
  props: {
    polarity: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>

.polarity-list {
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    display: flex;
    justify-content: center;
    align-items: center;

    &:not(:last-child) {
      margin-right: var(--ds-spacing-stack-nano);
    }

    & > span {
      display: inline-block;
      margin-right: var(--ds-spacing-stack-quark);
    }
  }
}

.sentiment-color {
  &--success {
    background-color: var(--ds-color-mantis);
  }

  &--neutral {
    background-color: var(--ds-color-butter);
  }

  &--negative {
    background-color: var(--ds-color-scarlet);
  }
}

</style>
